export class SimpleSearch {

    values: any;

    constructor() {
        this.values = {};
    }

    ToSearchParameters(): URLSearchParams {

        let result = new URLSearchParams();

        let defaultValues = {
            'page': 1,
            'count': 1
        };

        // Object.keys(this.values).forEach(x =>  {
        //     if(this.values[x]) {
        //         result.set(k, this.values[x]);
        //         return;
        //     }

        //     if(defaultValues[x]) {
        //         result.set(x, defaultValues[x]);
        //     }
        // });

        Object.keys(defaultValues).forEach(x => {
            if(!this.values[x]) {
                result.set(x, defaultValues[x]);
            }

        });

        return result;
    }

}
